<div class="main-content-container">
  @if (value) {
  @for (field of value; track field) {
    @if ((field.notes && field.notes.trim() !== '' && field.notes.trim() !== '<ul></ul>') || visibleNotes(field).length > 0 || field.documents !=undefined) {
      <div class="card">
        <div class="card-header">
          <div class="row col-12">
            <div class="col-6">
              Created By: @if (field.created_by_name != undefined) {
              <span>{{field.created_by_name}}</span>
            }
          </div>
          <div class="col-6 text-right">
            Created On: @if (field.creation_time != undefined) {
            <span>{{field.creation_time | dateTimeFormat}}</span>
          }
        </div>
      </div>
    </div>
    <div class="card-body">
      <!-- <div *ngIf="field.team_name != undefined">
      Assigned to : {{field.team_name}}
    </div>-->
    @if (field.notes != undefined) {
      <div [innerHtml]="field.notes">
      </div>
    }
    @if (visibleNotes(field).length > 0) {
      <ul>
        @for (note of visibleNotes(field); track $index) {
          <li>
            <b>{{note.key_text}}</b>
            @if (note.type == 'change') {
              change from {{note.key_old_value}} <b>to</b> {{note.key_current_value}}
            } @else {
              set to {{note.key_current_value}}
            }
          </li>
        }
      </ul>
    }
    <!-- <ng-container *ngIf="field.notes != undefined">
    <ul>
      <ng-container *ngFor="let note of extractNotes(field.notes)">
        <li>{{ note }}</li>
      </ng-container>
    </ul>
  </ng-container> -->
  @if (field.documents !=undefined) {
    <dhs-file-uploader [id]="field.documents" [multiple]="true"
      [formatsAllowed]="'.jpg,.gif,.png,.pdf,.doc'" [maxSize]="15" [resource]="'helpdesk_documents'" [question] = "question"
      [formAction]="'VIEW'" [value]="field.documents" [icon_with_text]=true>
    </dhs-file-uploader>
  }
</div>
<!-- <div class="card-footer text-muted"> -->
<!-- <dhs-file-uploader *ngIf="field.documents !=undefined" [id]="field.documents" [multiple]="true"
[formatsAllowed]="'.jpg,.gif,.png,.pdf,.doc'" [maxSize]="15" [resource]="'orgImage'"
[formAction]="'VIEW'" [value]="field.documents" [icon_with_text]=true>
</dhs-file-uploader> -->
<!-- Attachment: <span><i class="fa fa-paperclip"></i> Image_1.jpg</span> &nbsp;&nbsp;<span><i class="fa fa-paperclip"></i> Image_2.jpg</span>  -->
<!-- </div> -->
</div>
}
}
}
</div>